// extracted by mini-css-extract-plugin
module.exports = {"news-item-box":"aa","newsItemBox":"aa","img-box":"ab","imgBox":"ab","img-mask-box":"ac","imgMaskBox":"ac"};